export default __webpack_public_path__ + "static/dd805563-c51d-4e72-9f13-7bcffb8c5c28-a996ff0a2ef7e0b2d24bb236a9ab8e3c.eot";